export default {
  Authorize: {
    data: [
      [3,"4",{"idTagInfo":{"status":"Accepted"}}]
    ]
  },
  BootNotification: {
    data: [
      [3,"26",{"currentTime":"2020-12-24T03:03:49.684Z","interval":30,"status":"Accepted"}],
      [2,"4c27fdbe-b5d5-4c72-a9e2-8c33cd2009d5","ChangeAvailability",{"connectorId":0,"type":"Operative"}],
      [2,"9f8867f7-47cd-473c-8267-e6909471bd65","TriggerMessage",{"requestedMessage":"StatusNotification"}],
      [2,"63e483aa-570e-430c-afec-8bde940a9548","TriggerMessage",{"requestedMessage":"StopTransaction"}],
      [2,"497f744c-bde3-43c9-aa5f-d5ca88324ddb","ChangeConfiguration",{"key":"InsufficientBalanceAction","value":"StopOnly"}]
    ]
  },
  Heartbeat: {
    data: [
      [3,"4",{"currentTime":"2020-12-24T04:24:15.754Z"}]
    ]
  },
  MeterValues: {
    data: [
      [3,"4",{}]
    ]
  },
  StartTransaction: {
    data: [
      [3,"4",{"transactionId":47,"idTagInfo":{"status":"Accepted"}}]
    ]
  },
  StatusNotification: {
    data: [
      [3,"4",{}]
    ]
  },
  StopTransaction: {
    data: [
      [3,"4",{"idTagInfo":{"status":"Accepted"}}]
    ]
  },
  ChangeAvailability: {
    data: [
      [3,"4",{"status":"Accepted"}]
    ]
  },
  SetChargingProfile: {
    data: [
      [3,"4",{"status":"Accepted"}]
    ]
  },
  TriggerMessage: {
    data: [
      [3,"4",{"status":"Accepted"}]
    ]
  },
  DataTransfer: {
    data: [
      [3,"1",{"dataTransferStatus":"Accepted","data":{}}]
    ]
  }
}